import React from "react";
import { BaseClimatogi1 } from "../..";

const Index = () => {
  return (
    <div>
      <BaseClimatogi1/>
    </div>
  );
};

export default Index;
